import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { useAxios } from '@/composables/useAxios'
import { handleAxiosError } from '@/composables/useAxiosError'
import { STATUS_CODES } from '@/constants'
import { TaxConfig } from '@/types/config/TaxConfig'

export const useTaxConfigStore = defineStore('taxConfig', () => {
  const config = ref<TaxConfig | null>(null)
  const loaded = ref(false)
  const loading = ref(false)

  const isVatExempt = computed(() => config.value?.vat_exempt ?? false)
  const sellerCountry = computed(() => config.value?.seller_country ?? null)
  const defaultRate = computed(() => config.value?.default_rate ?? null)

  async function fetchConfig(): Promise<void> {
    if (loading.value || loaded.value) return

    loading.value = true

    try {
      const res = await useAxios<null, TaxConfig>('GET', '/config/tax', false)

      if (res && res.status === STATUS_CODES.OK && res.data) {
        const validated = TaxConfig.safeParse(res.data)
        if (validated.success) {
          config.value = validated.data
          loaded.value = true
        }
      }
    } catch (error) {
      handleAxiosError(error, { logPrefix: 'TaxConfigStore', reportNetworkErrors: false })
    } finally {
      loading.value = false
    }
  }

  return {
    config,
    loaded,
    loading,
    isVatExempt,
    sellerCountry,
    defaultRate,
    fetchConfig
  }
})
